import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { ShipmentPlannerProfileItemBriefState } from './shipment-planner-profile-item-brief.state';
import { ShipmentPlannerProfileDetails, ShipmentPlannerProfileModel } from '../models';
import { MatDialogRef } from '@angular/material/dialog';
import {
  ShipmentPlannerProfileItemBriefClone,
  ShipmentPlannerProfileItemBriefDelete,
  ShipmentPlannerProfileItemBriefInitialState,
  ShipmentPlannerProfileItemBriefLoad,
  ShipmentPlannerProfileItemBriefSave,
  ShipmentPlannerProfileItemBriefAffectedUsersLoad,
} from './shipment-planner-profile-item-brief.actions';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class ShipmentPlannerProfileItemBriefFacade implements LoadDataFacade, SetInitialStateFacade {
  profileId$: Observable<number> = this.store.select(ShipmentPlannerProfileItemBriefState.getProfileId);
  profile$: Observable<ShipmentPlannerProfileModel> = this.store.select(
    ShipmentPlannerProfileItemBriefState.getProfile,
  );
  loaded$: Observable<boolean> = this.store.select(ShipmentPlannerProfileItemBriefState.getLoaded);
  affectedUsers$: Observable<number> = this.store.select(ShipmentPlannerProfileItemBriefState.getAffectedUsers);
  affectedUsersLoaded$: Observable<boolean> = this.store.select(
    ShipmentPlannerProfileItemBriefState.getAffectedUsersLoaded,
  );

  constructor(private store: Store) {}

  loadAll(shipmentPlannerProfileId: number): void {
    this.store.dispatch(new ShipmentPlannerProfileItemBriefLoad(shipmentPlannerProfileId));
  }

  saveProfile(profile: Partial<ShipmentPlannerProfileDetails>): void {
    this.store.dispatch(new ShipmentPlannerProfileItemBriefSave(profile));
  }

  cloneProfile(data: Partial<ShipmentPlannerProfileModel>): void {
    this.store.dispatch(new ShipmentPlannerProfileItemBriefClone(data));
  }

  deleteProfile(profileId: number, dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>): void {
    this.store.dispatch(new ShipmentPlannerProfileItemBriefDelete({ dialog, profileId }));
  }

  getAffectedUsers(profileId: number): void {
    this.store.dispatch(new ShipmentPlannerProfileItemBriefAffectedUsersLoad(profileId));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentPlannerProfileItemBriefInitialState());
  }
}
